import axios from "axios";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  
  async salvarNotificacao(model) {
    return await instance.post("/message/notificacao/save", model).then(
      async response => {
        return await response.data;
      },
      error => {
        console.log(error);
      }
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/message.js